export enum Granularity {
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/model/granularity.ts